import React from 'react';
import useSnackbar from './Snackbar.hook';

const withSnackbar = (WrappedComponent) => (props) => {
  const snackbarProps = useSnackbar();
  return <WrappedComponent {...props} {...snackbarProps} />;
};

export default withSnackbar;
